// tabs
export const ADD_TAB = 'ADD_TAB'
export const DEL_TAB = 'DEL_TAB'
export const DEL_ALL_TABS = 'DEL_ALL_TABS'
export const DEL_ALL_OTHER_TABS = 'DEL_ALL_OTHER_TABS'
export const DEL_ONLY_CACHED_TAB = 'DEL_ONLY_CACHED_TAB'
export const UPDATE_TAB = 'UPDATE_TAB'
